import { useEffect } from "react";

export const ScrollTracker = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      sessionStorage.setItem("scroll_tracker", scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return null;
};
